/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable global-require */
import * as React from 'react';
import {Row, Col} from 'antd';
import {Footer} from 'antd/lib/layout/layout';
import logo from '~images/logo.png';
import {PhoneOutlined, MailOutlined} from '@ant-design/icons';
import FacebookCircle from './icons/facebook-circle';
import InstagramCircle from './icons/instagram-circle';
import TiktokCircle from './icons/tiktok-circle';
import {followUs} from '~constants/rentzy-info';
import {Link} from 'gatsby';

const FooterComponent = () => {
  return (
    <Footer className='layout-footer'>
      <Row className='footer-content' justify='center'>
        <Col style={{padding: '0 50px'}} lg={24} xl={22}>
          <img width='124px' src={logo} alt='Rentzy logo' className='rentzy-logo' />
          <Row>
            <Col span={2}>
              <PhoneOutlined style={{marginRight: 5}} /> <b>Hotline</b>
            </Col>
            <Col span={22}>079 896 9040 - 0847740084</Col>
            <Col span={2} />
            <Col span={22}>(8:00 - 22:00)</Col>
          </Row>
          <Row>
            <Col span={2}>
              <MailOutlined style={{marginRight: 5}} /> <b>Email</b>
            </Col>
            <Col span={22}>rental@rentzy.vn</Col>
          </Row>
          <Row style={{marginTop: '25px', marginBottom: '10px'}}>
            <b>CÔNG TY TNHH DREAM CLOSETS</b>
          </Row>
          <Row>MST: 0319375412</Row>
          <Row>
            <Col span={21}>51 đường 41, Phường Khánh Hội, Thành phố Hồ Chí Minh, Việt Nam</Col>
            <Col span={3} style={{display: 'flex', justifyContent: 'space-between'}}>
              <Link to={followUs.facebook} className='link-with-icon' target='_blank'>
                <FacebookCircle />
              </Link>
              <Link to={followUs.instagram} className='link-with-icon' target='_blank'>
                <InstagramCircle />
              </Link>
              <Link to={followUs.tiktok} className='link-with-icon' target='_blank'>
                <TiktokCircle />
              </Link>
            </Col>
          </Row>
        </Col>
      </Row>
      <div className='license'>&copy; 2021 - BẢN QUYỀN THUỘC VỀ HKD RENTZY</div>
    </Footer>
  );
};

export default FooterComponent;
